import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputCategoryMarkRelationModify<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: note */
  note?: string;
  /** Alias: categoryCode */
  categoryCode?: number;

  __typename?: string;
}

const fields: FieldDefinitions<InputCategoryMarkRelationModify> = {
  code: {
    alias: 'code',
  },
  note: {
    alias: 'note',
  },
  categoryCode: {
    alias: 'categoryCode',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputCategoryMarkRelationModifyEntityDefinition: EntitiyDefinition<InputCategoryMarkRelationModify> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputCategoryMarkRelationModify',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
